export default __webpack_public_path__ + "static/media/cont6.75cc8d9f.png";